<script setup lang="ts">
import { TheContent } from '@/modules/shared/components'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import OtherEntityNav from '../components/other-entity-nav.vue'
import OtherEntityHeader from '../components/other-entity-header.vue'
</script>

<template>
  <TheLayout>
    <OtherEntityHeader />
    <OtherEntityNav />
    <TheContent> Distributions Page </TheContent>
  </TheLayout>
</template>
